import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/gestion_proyecto/lineaPresupuestaria';
import Lineas from './lineaPresupuestaria';


const ms2p = (state) => {
  return {
    ...state.proyecto_linea,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Lineas);
